/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: Date; output: Date; }
  Geometry: { input: any; output: any; }
  GeometryZ: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Long: { input: any; output: any; }
};

export type ApplyDiscountInput = {
  organizationId: Scalars['ID']['input'];
  promoCode: Scalars['String']['input'];
};

export type Attachment = {
  __typename?: 'Attachment';
  batch?: Maybe<UploadBatch>;
  batchId?: Maybe<Scalars['ID']['output']>;
  byproducts: Array<Byproduct>;
  checksumSHA256Base64?: Maybe<Scalars['String']['output']>;
  contentLength?: Maybe<Scalars['Long']['output']>;
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  projectId?: Maybe<Scalars['ID']['output']>;
  s3Key: Scalars['String']['output'];
  status: AttachmentStatus;
  updatedAt: Scalars['DateTime']['output'];
  uploadId?: Maybe<Scalars['ID']['output']>;
  url: Scalars['String']['output'];
};

export enum AttachmentStatus {
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Uploaded = 'UPLOADED',
  Uploading = 'UPLOADING'
}

export enum BillingInterval {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

export enum BillingStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  None = 'NONE',
  PastDue = 'PAST_DUE',
  PendingPayment = 'PENDING_PAYMENT',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type Byproduct = {
  __typename?: 'Byproduct';
  contentLength?: Maybe<Scalars['Long']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  downloadUrl: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  processJobId: Scalars['ID']['output'];
  sourceAttachmentId?: Maybe<Scalars['ID']['output']>;
  type: ByproductType;
};

export enum ByproductType {
  Dxf = 'DXF',
  Laz = 'LAZ',
  Other = 'OTHER',
  Pdf = 'PDF',
  Rcs = 'RCS'
}

export type ChangeTierInput = {
  organizationId: Scalars['ID']['input'];
  tier: SubscriptionTier;
};

export enum CollectionMethod {
  Automatic = 'AUTOMATIC',
  SendInvoice = 'SEND_INVOICE'
}

export type CreateAttachmentResponse = {
  __typename?: 'CreateAttachmentResponse';
  attachment: Attachment;
  uploadUrl: Scalars['String']['output'];
};

export type CreateFeatureAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
  featureId: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type CreateFeatureInput = {
  geometry: Scalars['GeometryZ']['input'];
  geometryWGS84?: InputMaybe<Scalars['GeometryZ']['input']>;
  layerId: Scalars['ID']['input'];
  properties: Scalars['JSON']['input'];
};

export type CreateImageInput = {
  attachmentId: Scalars['ID']['input'];
  layerId: Scalars['ID']['input'];
  location: Scalars['Geometry']['input'];
  locationWGS84: Scalars['Geometry']['input'];
  projectId: Scalars['ID']['input'];
};

export type CreateLayerInput = {
  bbox?: InputMaybe<Scalars['Geometry']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentLayerId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  type: LayerType;
};

export type CreateOrganizationInput = {
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type CreateProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  srid: Scalars['Int']['input'];
};

export type CreateSubscriptionInput = {
  billingInterval: BillingInterval;
  cancelUrl: Scalars['String']['input'];
  collectionMethod: CollectionMethod;
  organizationId: Scalars['ID']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  storageBlocks: Scalars['Int']['input'];
  successUrl: Scalars['String']['input'];
  tier: SubscriptionTier;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubscriptionResult = {
  __typename?: 'CreateSubscriptionResult';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DiscountInfo = {
  __typename?: 'DiscountInfo';
  amountOff?: Maybe<Scalars['Int']['output']>;
  couponId: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Float']['output']>;
  promoCodeId?: Maybe<Scalars['String']['output']>;
};

export enum ExportType {
  Csv = 'CSV',
  Geojson = 'GEOJSON'
}

export type Feature = {
  __typename?: 'Feature';
  createdAt: Scalars['DateTime']['output'];
  geometry: Scalars['GeometryZ']['output'];
  geometryWGS84: Scalars['GeometryZ']['output'];
  id: Scalars['ID']['output'];
  layerId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  properties: Scalars['JSON']['output'];
  serial: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FeatureAttachment = {
  __typename?: 'FeatureAttachment';
  attachment: Attachment;
  attachmentId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadedBy: User;
  uploadedById: Scalars['ID']['output'];
};

export type FeatureFilter = {
  key: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type FeatureOrder = {
  direction?: OrderDirection;
  field: Scalars['String']['input'];
};

export type FeaturePaginated = {
  __typename?: 'FeaturePaginated';
  cursor?: Maybe<Scalars['String']['output']>;
  features: Array<Feature>;
  total: Scalars['Int']['output'];
};

export type FeaturebaseUser = {
  __typename?: 'FeaturebaseUser';
  email?: Maybe<Scalars['String']['output']>;
  featurebaseJwt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Scalars['String']['output'];
  profilePicture?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type GoogleImage = {
  __typename?: 'GoogleImage';
  copyright: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['String']['output'];
  heading: Scalars['Float']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  locationWGS84: Scalars['GeometryZ']['output'];
  panoId: Scalars['String']['output'];
  roll: Scalars['Float']['output'];
  root: Scalars['String']['output'];
  tilt: Scalars['Float']['output'];
  width: Scalars['Int']['output'];
};

export type Image = {
  __typename?: 'Image';
  attachmentId?: Maybe<Scalars['ID']['output']>;
  cameraType?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  filename: Scalars['String']['output'];
  focalLengthX?: Maybe<Scalars['Float']['output']>;
  focalLengthY?: Maybe<Scalars['Float']['output']>;
  groupId: Scalars['Int']['output'];
  hasCompressedVariants: Scalars['Boolean']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  k1?: Maybe<Scalars['Float']['output']>;
  k2?: Maybe<Scalars['Float']['output']>;
  k3?: Maybe<Scalars['Float']['output']>;
  k4?: Maybe<Scalars['Float']['output']>;
  largeFilename?: Maybe<Scalars['String']['output']>;
  layer: Layer;
  layerId?: Maybe<Scalars['ID']['output']>;
  location: Scalars['Geometry']['output'];
  locationWGS84: Scalars['Geometry']['output'];
  organizationId: Scalars['ID']['output'];
  p1?: Maybe<Scalars['Float']['output']>;
  p2?: Maybe<Scalars['Float']['output']>;
  pixelHeight: Scalars['Float']['output'];
  pixelWidth: Scalars['Float']['output'];
  principalPointX?: Maybe<Scalars['Float']['output']>;
  principalPointY?: Maybe<Scalars['Float']['output']>;
  projectId: Scalars['ID']['output'];
  rotationMatrix: Array<Scalars['Float']['output']>;
  rotationQuaternion: Array<Scalars['Float']['output']>;
  smallFilename?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  width: Scalars['Int']['output'];
};

export type InviteUserInput = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname?: InputMaybe<Scalars['String']['input']>;
  role: UserOrganizationRole;
};

export type Invoice = {
  __typename?: 'Invoice';
  amountDue: Scalars['Int']['output'];
  amountPaid: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  number?: Maybe<Scalars['String']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  amount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type InvoicePreview = {
  __typename?: 'InvoicePreview';
  amountDue: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  lines: Array<InvoiceLineItem>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
};

export type Layer = {
  __typename?: 'Layer';
  bbox?: Maybe<Scalars['Geometry']['output']>;
  bboxNew?: Maybe<Scalars['Geometry']['output']>;
  center?: Maybe<Scalars['Geometry']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isHidden: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  parentLayerId?: Maybe<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  propertyAliases: Array<PropertyAlias>;
  root?: Maybe<Scalars['String']['output']>;
  settings: LayerSettings;
  sourceAttachment?: Maybe<Attachment>;
  sourceAttachmentId?: Maybe<Scalars['ID']['output']>;
  subLayers: Array<Layer>;
  type: LayerType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

export type LayerSettings = {
  __typename?: 'LayerSettings';
  imagePointColor: Scalars['String']['output'];
  modelDefaultColor: Scalars['String']['output'];
  modelIsWireframe: Scalars['Boolean']['output'];
  pointCloudClasses: Array<PointCloudClassSettings>;
  pointCloudFixedColor: Scalars['String']['output'];
  pointCloudMaterialColor: PointColorType;
  pointCloudMaterialColorSource: Scalars['Int']['output'];
  vectorDefaultColor: Scalars['String']['output'];
  vectorDefaultOpacity: Scalars['Float']['output'];
  vectorDefaultPointSize: Scalars['Float']['output'];
  vectorIsWireframe: Scalars['Boolean']['output'];
};

export type LayerSettingsInput = {
  imagePointColor: Scalars['String']['input'];
  modelDefaultColor: Scalars['String']['input'];
  modelIsWireframe: Scalars['Boolean']['input'];
  pointCloudClasses: Array<PointCloudClassSettingsInput>;
  pointCloudFixedColor: Scalars['String']['input'];
  pointCloudMaterialColor: PointColorType;
  pointCloudMaterialColorSource: Scalars['Int']['input'];
  vectorDefaultColor: Scalars['String']['input'];
  vectorDefaultOpacity: Scalars['Float']['input'];
  vectorDefaultPointSize: Scalars['Float']['input'];
  vectorIsWireframe: Scalars['Boolean']['input'];
};

export enum LayerType {
  Group = 'GROUP',
  Image = 'IMAGE',
  Model = 'MODEL',
  Pointcloud = 'POINTCLOUD',
  Tile = 'TILE',
  Vector = 'VECTOR'
}

export type Mutation = {
  __typename?: 'Mutation';
  abortUpload: Scalars['Boolean']['output'];
  acceptInvitation: UserInvitationResult;
  applySubscriptionDiscount: Scalars['Boolean']['output'];
  cancelSubscription: Scalars['Boolean']['output'];
  changeSubscriptionTier: Scalars['Boolean']['output'];
  completeBatch: Scalars['Boolean']['output'];
  completeUpload: Attachment;
  createAttachment: CreateAttachmentResponse;
  createBillingPortalSession: Scalars['String']['output'];
  createFeature: Feature;
  createFeatureAttachment: FeatureAttachment;
  createImage: Image;
  createLayer: Layer;
  createOrganization: Organization;
  createProject: Project;
  createProjectLink: ProjectLink;
  createSubscription: CreateSubscriptionResult;
  deleteAttachment: Scalars['Boolean']['output'];
  deleteBatch: Scalars['Boolean']['output'];
  deleteFeature: Scalars['Boolean']['output'];
  deleteFeatureAttachment: Scalars['Boolean']['output'];
  deleteFeatures: Scalars['Boolean']['output'];
  deleteImage: Scalars['Boolean']['output'];
  deleteLayer: Scalars['Boolean']['output'];
  deleteOrganization: Scalars['Boolean']['output'];
  deletePasskey: Scalars['Boolean']['output'];
  deleteProject: Scalars['Boolean']['output'];
  deleteProjectLink: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  disableAuthenticatorTwoFactor: Scalars['Boolean']['output'];
  disableTwoFactor: Scalars['Boolean']['output'];
  downloadFeatures: Scalars['String']['output'];
  inviteOnboardingUsers: Scalars['Boolean']['output'];
  inviteUserToOrganization: Scalars['Boolean']['output'];
  inviteUsersToOrganization: Scalars['Boolean']['output'];
  reactivateSubscription: Scalars['Boolean']['output'];
  removeSubscriptionDiscount: Scalars['Boolean']['output'];
  removeUserFromOrganization: Scalars['Boolean']['output'];
  renamePasskey: Scalars['Boolean']['output'];
  resetBatch: Scalars['Boolean']['output'];
  revokeInvitation: Scalars['Boolean']['output'];
  revokeSession: Scalars['Boolean']['output'];
  saveOnboardingSurvey: Scalars['Boolean']['output'];
  setupAuthenticatorTwoFactor: SetupAuthenticatorResult;
  setupTwoFactor: SetupTwoFactorResult;
  startBatch: UploadBatch;
  startBatchProcessing: Scalars['Boolean']['output'];
  startUpload: Attachment;
  updateEmail: Scalars['Boolean']['output'];
  updateFeature: Feature;
  updateFeatureAttachment: FeatureAttachment;
  updateFeatures: Array<Feature>;
  updateImage: Image;
  updateLayer: Layer;
  updateLayerSettings: Scalars['Boolean']['output'];
  updateOrganization: Organization;
  updatePassword: Scalars['Boolean']['output'];
  updateProject: Project;
  updateProjectLinkPassword: ProjectLink;
  updateSubscriptionStorage: Scalars['Boolean']['output'];
  updateTheme: Scalars['Boolean']['output'];
  updateUser: User;
  updateUserRoleInOrganization: Scalars['Boolean']['output'];
  updateViewerSettings: Scalars['Boolean']['output'];
  uploadPart: Scalars['String']['output'];
  verifyAuthenticatorTwoFactorSetup: Scalars['Boolean']['output'];
  verifyTwoFactorSetup: Scalars['Boolean']['output'];
};


export type MutationAbortUploadArgs = {
  attachmentId: Scalars['ID']['input'];
};


export type MutationAcceptInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationApplySubscriptionDiscountArgs = {
  input: ApplyDiscountInput;
};


export type MutationCancelSubscriptionArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationChangeSubscriptionTierArgs = {
  input: ChangeTierInput;
};


export type MutationCompleteBatchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompleteUploadArgs = {
  attachmentId: Scalars['ID']['input'];
  parts: Array<S3CompletedPart>;
};


export type MutationCreateAttachmentArgs = {
  checksumSHA256Base64?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  project?: InputMaybe<Scalars['ID']['input']>;
  type: UploadType;
};


export type MutationCreateBillingPortalSessionArgs = {
  organizationId: Scalars['ID']['input'];
  returnUrl: Scalars['String']['input'];
};


export type MutationCreateFeatureArgs = {
  input: CreateFeatureInput;
};


export type MutationCreateFeatureAttachmentArgs = {
  input: CreateFeatureAttachmentInput;
};


export type MutationCreateImageArgs = {
  input: CreateImageInput;
};


export type MutationCreateLayerArgs = {
  input: CreateLayerInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateProjectLinkArgs = {
  expiresAt: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationDeleteAttachmentArgs = {
  attachmentId: Scalars['ID']['input'];
};


export type MutationDeleteBatchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeatureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeatureAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeaturesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteImageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLayerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
};


export type MutationDeletePasskeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
};


export type MutationDisableAuthenticatorTwoFactorArgs = {
  code: Scalars['String']['input'];
};


export type MutationDisableTwoFactorArgs = {
  code: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


export type MutationDownloadFeaturesArgs = {
  exportType: ExportType;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  layerId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationInviteOnboardingUsersArgs = {
  invitees: Array<OnboardingInviteInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationInviteUserToOrganizationArgs = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  role: UserOrganizationRole;
};


export type MutationInviteUsersToOrganizationArgs = {
  invitees: Array<InviteUserInput>;
  organizationId: Scalars['ID']['input'];
};


export type MutationReactivateSubscriptionArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationRemoveSubscriptionDiscountArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRenamePasskeyArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationResetBatchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeSessionArgs = {
  sessionId: Scalars['ID']['input'];
};


export type MutationSaveOnboardingSurveyArgs = {
  data: Scalars['JSON']['input'];
};


export type MutationSetupTwoFactorArgs = {
  mobileNumber: Scalars['String']['input'];
};


export type MutationStartBatchArgs = {
  numberOfAttachments: Scalars['Int']['input'];
  project: Scalars['ID']['input'];
};


export type MutationStartBatchProcessingArgs = {
  compressImages?: InputMaybe<Scalars['Boolean']['input']>;
  dxfOutputVersion?: InputMaybe<Scalars['String']['input']>;
  generateRcs?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  maxZoom?: InputMaybe<Scalars['Int']['input']>;
  minZoom?: InputMaybe<Scalars['Int']['input']>;
  pointCloudAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  srid: Scalars['Int']['input'];
  tileSize?: InputMaybe<Scalars['Int']['input']>;
  type: ProcessJobType;
};


export type MutationStartUploadArgs = {
  batch?: InputMaybe<Scalars['ID']['input']>;
  checksumSHA256Base64?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  project: Scalars['ID']['input'];
};


export type MutationUpdateEmailArgs = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateFeatureArgs = {
  input: UpdateFeatureInput;
};


export type MutationUpdateFeatureAttachmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFeatureAttachmentInput;
};


export type MutationUpdateFeaturesArgs = {
  input: Array<UpdateFeatureInput>;
};


export type MutationUpdateImageArgs = {
  input: UpdateImageInput;
};


export type MutationUpdateLayerArgs = {
  input: UpdateLayerInput;
};


export type MutationUpdateLayerSettingsArgs = {
  id: Scalars['ID']['input'];
  input: LayerSettingsInput;
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganizationInput;
};


export type MutationUpdatePasswordArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePasswordInput;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdateProjectLinkPasswordArgs = {
  id: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSubscriptionStorageArgs = {
  input: UpdateStorageInput;
};


export type MutationUpdateThemeArgs = {
  theme: ThemePreference;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};


export type MutationUpdateUserRoleInOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  role: UserOrganizationRole;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateViewerSettingsArgs = {
  input: ViewerSettingsInput;
};


export type MutationUploadPartArgs = {
  attachmentId: Scalars['ID']['input'];
  checksumSHA256Base64: Scalars['String']['input'];
  contentLength: Scalars['Int']['input'];
  partNumber: Scalars['Int']['input'];
};


export type MutationVerifyAuthenticatorTwoFactorSetupArgs = {
  code: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


export type MutationVerifyTwoFactorSetupArgs = {
  code: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export type OnboardingInviteInput = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Organization = {
  __typename?: 'Organization';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Attachment>;
  logoId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  projects?: Maybe<Array<Project>>;
  role?: Maybe<UserOrganizationRole>;
  slug?: Maybe<Scalars['String']['output']>;
  storageLimitBytes: Scalars['Long']['output'];
  storageUsedBytes: Scalars['Long']['output'];
  subscription: SubscriptionInfo;
  updatedAt: Scalars['DateTime']['output'];
};

export type PointCloudClassSettings = {
  __typename?: 'PointCloudClassSettings';
  color: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
};

export type PointCloudClassSettingsInput = {
  color: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
};

export enum PointCloudPointSizeType {
  Adaptive = 'ADAPTIVE',
  Fixed = 'FIXED'
}

export enum PointColorType {
  Grayscale = 'GRAYSCALE',
  Inferno = 'INFERNO',
  Plasma = 'PLASMA',
  Rainbow = 'RAINBOW',
  Rgb = 'RGB',
  Spectral = 'SPECTRAL',
  Viridis = 'VIRIDIS',
  YellowGreen = 'YELLOW_GREEN'
}

export type PricingInfo = {
  __typename?: 'PricingInfo';
  currency: Scalars['String']['output'];
  tiers: Array<TierPricing>;
};

export type PricingTier = {
  __typename?: 'PricingTier';
  unitAmount: Scalars['Int']['output'];
  unitAmountDecimal: Scalars['String']['output'];
  upTo?: Maybe<Scalars['Int']['output']>;
};

export type ProcessJob = {
  __typename?: 'ProcessJob';
  attempts: Scalars['Int']['output'];
  batchId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  errorLogs?: Maybe<Scalars['String']['output']>;
  estimatedCompletion?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inputJson: Scalars['JSON']['output'];
  isLeaf: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  leaseUntil?: Maybe<Scalars['DateTime']['output']>;
  logStream?: Maybe<Scalars['String']['output']>;
  logs?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  outputJson?: Maybe<Scalars['JSON']['output']>;
  parentItemId?: Maybe<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ProcessJobStatus;
  type: ProcessJobType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ProcessJobStatus {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Waiting = 'WAITING'
}

export enum ProcessJobType {
  Dwg = 'DWG',
  Dxf = 'DXF',
  E57 = 'E57',
  FjdImage = 'FJD_IMAGE',
  Geojson = 'GEOJSON',
  Geotiff = 'GEOTIFF',
  Ifc = 'IFC',
  Image = 'IMAGE',
  ImageCompression = 'IMAGE_COMPRESSION',
  Iprj = 'IPRJ',
  Landxml = 'LANDXML',
  Las = 'LAS',
  Post = 'POST',
  Pts = 'PTS',
  Rcs = 'RCS',
  Shp = 'SHP',
  Xgrids = 'XGRIDS'
}

export type Project = {
  __typename?: 'Project';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialAngle: Scalars['Int']['output'];
  initialPosition?: Maybe<Scalars['GeometryZ']['output']>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  srid: Scalars['Int']['output'];
  storageUsedBytes: Scalars['Long']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID']['output'];
};

export type ProjectLink = {
  __typename?: 'ProjectLink';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  projectId: Scalars['ID']['output'];
  status: ProjectLinkStatus;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum ProjectLinkStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Expired = 'EXPIRED'
}

export type PromoCodeValidation = {
  __typename?: 'PromoCodeValidation';
  amountOff?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Float']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type PropertyAlias = {
  __typename?: 'PropertyAlias';
  alias: Scalars['String']['output'];
  property: Scalars['String']['output'];
};

export type PropertyAliasInput = {
  alias: Scalars['String']['input'];
  property: Scalars['String']['input'];
};

export type PropertyValues = {
  __typename?: 'PropertyValues';
  property: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  allProjectLinks: Array<ProjectLink>;
  attachments: Array<Attachment>;
  attachmentsByBatch: Array<Attachment>;
  batch: UploadBatch;
  batches: Array<UploadBatch>;
  feature: Feature;
  featureAttachment: FeatureAttachment;
  featureAttachments: Array<FeatureAttachment>;
  features: Array<Feature>;
  featuresByIds: Array<Feature>;
  featuresByLayer: Array<Feature>;
  featuresPaginated: FeaturePaginated;
  googleImage: GoogleImage;
  googleImageByPanoId: GoogleImage;
  googleImagesByPosition: Array<GoogleImage>;
  image: Image;
  images: Array<Image>;
  imagesByLayer: Array<Image>;
  invitations: Array<UserInvitation>;
  jobs: Array<ProcessJob>;
  jobsByBatch: Array<ProcessJob>;
  layer: Layer;
  layerProperties: Array<Scalars['String']['output']>;
  layerPropertyValues: Array<PropertyValues>;
  layers: Array<Layer>;
  layersNested: Array<Layer>;
  me: User;
  organization: Organization;
  organizations: Array<Organization>;
  project: Project;
  projectLinks: Array<ProjectLink>;
  projects: Array<Project>;
  sharedProject: Project;
  slugAvailable: Scalars['Boolean']['output'];
  srids: Array<Srid>;
  subscriptionDetails: SubscriptionDetails;
  subscriptionPricing: PricingInfo;
  user: User;
  userPasskeys: Array<UserPasskey>;
  userSessions: Array<UserSession>;
  users: Array<User>;
  validatePromoCode: PromoCodeValidation;
};


export type QueryAttachmentsByBatchArgs = {
  batchId: Scalars['ID']['input'];
};


export type QueryBatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBatchesArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryFeatureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeatureAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeatureAttachmentsArgs = {
  featureId: Scalars['ID']['input'];
};


export type QueryFeaturesArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryFeaturesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryFeaturesByLayerArgs = {
  layerIds: Array<Scalars['ID']['input']>;
};


export type QueryFeaturesPaginatedArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FeatureFilter>>;
  layerId?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<FeatureOrder>;
  projectId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGoogleImageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGoogleImageByPanoIdArgs = {
  panoId: Scalars['String']['input'];
};


export type QueryGoogleImagesByPositionArgs = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};


export type QueryImageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImagesArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryImagesByLayerArgs = {
  layerIds: Array<Scalars['ID']['input']>;
};


export type QueryJobsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryJobsByBatchArgs = {
  batchId: Scalars['ID']['input'];
};


export type QueryLayerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLayerPropertiesArgs = {
  layerId: Scalars['ID']['input'];
};


export type QueryLayerPropertyValuesArgs = {
  layerId: Scalars['ID']['input'];
};


export type QueryLayersArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryLayersNestedArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectLinksArgs = {
  projectId: Scalars['ID']['input'];
};


export type QuerySlugAvailableArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySubscriptionDetailsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserSessionsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryValidatePromoCodeArgs = {
  code: Scalars['String']['input'];
};

export type S3CompletedPart = {
  ChecksumSHA256: Scalars['String']['input'];
  ETag: Scalars['String']['input'];
  PartNumber: Scalars['Int']['input'];
};

export type Srid = {
  __typename?: 'SRID';
  name: Scalars['String']['output'];
  projection: Scalars['String']['output'];
  srid: Scalars['Int']['output'];
};

export type SetupAuthenticatorResult = {
  __typename?: 'SetupAuthenticatorResult';
  otpauthUri: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type SetupTwoFactorResult = {
  __typename?: 'SetupTwoFactorResult';
  secret: Scalars['String']['output'];
};

export type StoragePricing = {
  __typename?: 'StoragePricing';
  annual: Array<PricingTier>;
  monthly: Array<PricingTier>;
};

export type SubscriptionDetails = {
  __typename?: 'SubscriptionDetails';
  discount?: Maybe<DiscountInfo>;
  info: SubscriptionInfo;
  invoices: Array<Invoice>;
  nextInvoicePreview?: Maybe<InvoicePreview>;
};

export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  billingInterval?: Maybe<BillingInterval>;
  billingStatus: BillingStatus;
  cancelAt?: Maybe<Scalars['DateTime']['output']>;
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  collectionMethod?: Maybe<CollectionMethod>;
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  scheduledChangeAt?: Maybe<Scalars['DateTime']['output']>;
  scheduledStorageBlocks?: Maybe<Scalars['Int']['output']>;
  scheduledTier?: Maybe<SubscriptionTier>;
  storageBlocks: Scalars['Int']['output'];
  storageLimitBytes: Scalars['Long']['output'];
  tier: SubscriptionTier;
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum SubscriptionTier {
  Core = 'CORE',
  Enterprise = 'ENTERPRISE',
  Free = 'FREE',
  Lite = 'LITE',
  Plus = 'PLUS'
}

export enum ThemePreference {
  Dark = 'DARK',
  Light = 'LIGHT',
  System = 'SYSTEM'
}

export type TierPricing = {
  __typename?: 'TierPricing';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  storage: StoragePricing;
  tier: SubscriptionTier;
};

export enum TwoFactorType {
  Authenticator = 'AUTHENTICATOR',
  Sms = 'SMS'
}

export type UpdateFeatureAttachmentInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeatureInput = {
  geometry?: InputMaybe<Scalars['GeometryZ']['input']>;
  geometryWGS84?: InputMaybe<Scalars['GeometryZ']['input']>;
  id: Scalars['ID']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateImageInput = {
  id: Scalars['ID']['input'];
  layerId?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['Geometry']['input']>;
  locationWGS84?: InputMaybe<Scalars['Geometry']['input']>;
};

export type UpdateLayerInput = {
  bbox?: InputMaybe<Scalars['Geometry']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentLayerId?: InputMaybe<Scalars['ID']['input']>;
  propertyAliases?: InputMaybe<Array<PropertyAliasInput>>;
  type?: InputMaybe<LayerType>;
};

export type UpdateOrganizationInput = {
  logoId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type UpdateProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  initialAngle?: InputMaybe<Scalars['Int']['input']>;
  initialPosition?: InputMaybe<Scalars['GeometryZ']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStorageInput = {
  organizationId: Scalars['ID']['input'];
  storageBlocks: Scalars['Int']['input'];
};

export type UpdateUserInput = {
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UploadBatch = {
  __typename?: 'UploadBatch';
  attachments: Array<Attachment>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  jobs: Array<ProcessJob>;
  key: Scalars['String']['output'];
  numberOfAttachments: Scalars['Int']['output'];
  processingCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  processingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  srid: Scalars['Int']['output'];
  status: UploadBatchStatus;
};

export enum UploadBatchStatus {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Uploading = 'UPLOADING',
  Waiting = 'WAITING'
}

export enum UploadType {
  FeatureAttachment = 'FEATURE_ATTACHMENT',
  OrganizationLogo = 'ORGANIZATION_LOGO',
  UserAvatar = 'USER_AVATAR'
}

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Attachment>;
  avatarId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  featurebaseUser?: Maybe<FeaturebaseUser>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  mobileNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  onboardingSurveyCompleted: Scalars['Boolean']['output'];
  role?: Maybe<UserOrganizationRole>;
  theme: ThemePreference;
  twoFactorEnabled: Scalars['Boolean']['output'];
  twoFactorType?: Maybe<TwoFactorType>;
  updatedAt: Scalars['DateTime']['output'];
  viewerSettings: UserViewerSettings;
};

export type UserInvitation = {
  __typename?: 'UserInvitation';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  role: UserOrganizationRole;
};

export type UserInvitationResult = {
  __typename?: 'UserInvitationResult';
  error?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  success: Scalars['Boolean']['output'];
};

export enum UserOrganizationRole {
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  Member = 'MEMBER'
}

export type UserPasskey = {
  __typename?: 'UserPasskey';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type UserSession = {
  __typename?: 'UserSession';
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  ipHash: Scalars['String']['output'];
  lastUsedAt: Scalars['DateTime']['output'];
  loginMethod: UserSessionMethod;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  status: UserSessionStatus;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export enum UserSessionMethod {
  Otp = 'OTP',
  Password = 'PASSWORD'
}

export enum UserSessionStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

export type UserViewerSettings = {
  __typename?: 'UserViewerSettings';
  googleStreetViewPoiColor?: Maybe<Scalars['String']['output']>;
  pointCloudPointBudget: Scalars['Int']['output'];
  pointCloudPointSize: Scalars['Float']['output'];
  pointCloudPointSizeType: PointCloudPointSizeType;
  showImagePOIs: Scalars['Boolean']['output'];
  showLayerSource: Scalars['Boolean']['output'];
  showLayerUnderType: Scalars['Boolean']['output'];
  showPointCloudBoundingBoxes: Scalars['Boolean']['output'];
};

export type ViewerSettingsInput = {
  googleStreetViewPoiColor?: InputMaybe<Scalars['String']['input']>;
  pointCloudPointBudget: Scalars['Int']['input'];
  pointCloudPointSize: Scalars['Float']['input'];
  pointCloudPointSizeType: PointCloudPointSizeType;
  showImagePOIs: Scalars['Boolean']['input'];
  showLayerSource: Scalars['Boolean']['input'];
  showLayerUnderType: Scalars['Boolean']['input'];
  showPointCloudBoundingBoxes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, name: string, description?: string | null, srid: number } };

export type CreateProjectLinkMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  expiresAt: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateProjectLinkMutation = { __typename?: 'Mutation', createProjectLink: { __typename?: 'ProjectLink', id: string, projectId: string, token: string, hasPassword: boolean, expiresAt: Date, createdAt: Date, createdById: string, createdBy?: { __typename?: 'User', id: string, name: string, email: string } | null } };

export type UpdateProjectLinkPasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectLinkPasswordMutation = { __typename?: 'Mutation', updateProjectLinkPassword: { __typename?: 'ProjectLink', id: string, hasPassword: boolean } };

export type DeleteProjectLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectLinkMutation = { __typename?: 'Mutation', deleteProjectLink: boolean };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: boolean };

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'CreateSubscriptionResult', type: string, url: string } };

export type UpdateSubscriptionStorageMutationVariables = Exact<{
  input: UpdateStorageInput;
}>;


export type UpdateSubscriptionStorageMutation = { __typename?: 'Mutation', updateSubscriptionStorage: boolean };

export type ChangeSubscriptionTierMutationVariables = Exact<{
  input: ChangeTierInput;
}>;


export type ChangeSubscriptionTierMutation = { __typename?: 'Mutation', changeSubscriptionTier: boolean };

export type CancelSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: boolean };

export type ReactivateSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type ReactivateSubscriptionMutation = { __typename?: 'Mutation', reactivateSubscription: boolean };

export type ApplySubscriptionDiscountMutationVariables = Exact<{
  input: ApplyDiscountInput;
}>;


export type ApplySubscriptionDiscountMutation = { __typename?: 'Mutation', applySubscriptionDiscount: boolean };

export type RemoveSubscriptionDiscountMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type RemoveSubscriptionDiscountMutation = { __typename?: 'Mutation', removeSubscriptionDiscount: boolean };

export type CreateBillingPortalSessionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  returnUrl: Scalars['String']['input'];
}>;


export type CreateBillingPortalSessionMutation = { __typename?: 'Mutation', createBillingPortalSession: string };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, name: string, mobileNumber?: string | null, avatar?: { __typename?: 'Attachment', id: string, url: string } | null } };

export type UpdatePasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type UpdateEmailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateEmail: boolean };

export type RevokeSessionMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type RevokeSessionMutation = { __typename?: 'Mutation', revokeSession: boolean };

export type UpdateThemeMutationVariables = Exact<{
  theme: ThemePreference;
}>;


export type UpdateThemeMutation = { __typename?: 'Mutation', updateTheme: boolean };

export type UpdateViewerSettingsMutationVariables = Exact<{
  input: ViewerSettingsInput;
}>;


export type UpdateViewerSettingsMutation = { __typename?: 'Mutation', updateViewerSettings: boolean };

export type SaveOnboardingSurveyMutationVariables = Exact<{
  data: Scalars['JSON']['input'];
}>;


export type SaveOnboardingSurveyMutation = { __typename?: 'Mutation', saveOnboardingSurvey: boolean };

export type SetupTwoFactorMutationVariables = Exact<{
  mobileNumber: Scalars['String']['input'];
}>;


export type SetupTwoFactorMutation = { __typename?: 'Mutation', setupTwoFactor: { __typename?: 'SetupTwoFactorResult', secret: string } };

export type VerifyTwoFactorSetupMutationVariables = Exact<{
  secret: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifyTwoFactorSetupMutation = { __typename?: 'Mutation', verifyTwoFactorSetup: boolean };

export type SetupAuthenticatorTwoFactorMutationVariables = Exact<{ [key: string]: never; }>;


export type SetupAuthenticatorTwoFactorMutation = { __typename?: 'Mutation', setupAuthenticatorTwoFactor: { __typename?: 'SetupAuthenticatorResult', secret: string, otpauthUri: string } };

export type VerifyAuthenticatorTwoFactorSetupMutationVariables = Exact<{
  secret: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifyAuthenticatorTwoFactorSetupMutation = { __typename?: 'Mutation', verifyAuthenticatorTwoFactorSetup: boolean };

export type DisableTwoFactorMutationVariables = Exact<{
  secret: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type DisableTwoFactorMutation = { __typename?: 'Mutation', disableTwoFactor: boolean };

export type DisableAuthenticatorTwoFactorMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type DisableAuthenticatorTwoFactorMutation = { __typename?: 'Mutation', disableAuthenticatorTwoFactor: boolean };

export type GetAttachmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAttachmentsQuery = { __typename?: 'Query', attachments: Array<{ __typename?: 'Attachment', id: string, url: string, s3Key: string, uploadId?: string | null, filename: string, contentType: string, contentLength?: any | null, checksumSHA256Base64?: string | null, status: AttachmentStatus, createdAt: Date, updatedAt: Date, deletedAt?: Date | null, organizationId: string, projectId?: string | null }> };

export type GetAttachmentsByBatchQueryVariables = Exact<{
  batchId: Scalars['ID']['input'];
}>;


export type GetAttachmentsByBatchQuery = { __typename?: 'Query', attachmentsByBatch: Array<{ __typename?: 'Attachment', id: string, url: string, s3Key: string, uploadId?: string | null, filename: string, contentType: string, contentLength?: any | null, checksumSHA256Base64?: string | null, status: AttachmentStatus, createdAt: Date, updatedAt: Date, organizationId: string, projectId?: string | null }> };

export type StartUploadMutationVariables = Exact<{
  project: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  checksumSHA256Base64?: InputMaybe<Scalars['String']['input']>;
  batch?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StartUploadMutation = { __typename?: 'Mutation', attachment: { __typename?: 'Attachment', id: string, url: string, s3Key: string, uploadId?: string | null, batchId?: string | null, filename: string, contentType: string, contentLength?: any | null, checksumSHA256Base64?: string | null, status: AttachmentStatus, createdAt: Date, updatedAt: Date, organizationId: string, projectId?: string | null } };

export type StartUploadBatchMutationVariables = Exact<{
  project: Scalars['ID']['input'];
  numberOfAttachments: Scalars['Int']['input'];
}>;


export type StartUploadBatchMutation = { __typename?: 'Mutation', batch: { __typename?: 'UploadBatch', id: string } };

export type CompleteUploadBatchMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompleteUploadBatchMutation = { __typename?: 'Mutation', success: boolean };

export type UploadPartMutationVariables = Exact<{
  attachmentId: Scalars['ID']['input'];
  partNumber: Scalars['Int']['input'];
  contentLength: Scalars['Int']['input'];
  checksumSHA256Base64: Scalars['String']['input'];
}>;


export type UploadPartMutation = { __typename?: 'Mutation', url: string };

export type CompleteUploadMutationVariables = Exact<{
  attachmentId: Scalars['ID']['input'];
  parts: Array<S3CompletedPart> | S3CompletedPart;
}>;


export type CompleteUploadMutation = { __typename?: 'Mutation', attachment: { __typename?: 'Attachment', id: string, url: string, s3Key: string, uploadId?: string | null, filename: string, contentType: string, contentLength?: any | null, checksumSHA256Base64?: string | null, status: AttachmentStatus, createdAt: Date, updatedAt: Date, organizationId: string, projectId?: string | null } };

export type AbortUploadMutationVariables = Exact<{
  attachmentId: Scalars['ID']['input'];
}>;


export type AbortUploadMutation = { __typename?: 'Mutation', success: boolean };

export type StartBatchMutationVariables = Exact<{
  project: Scalars['ID']['input'];
  numberOfAttachments: Scalars['Int']['input'];
}>;


export type StartBatchMutation = { __typename?: 'Mutation', batch: { __typename?: 'UploadBatch', id: string, status: UploadBatchStatus, createdAt: Date, createdById?: string | null, numberOfAttachments: number, processingStartedAt?: Date | null, processingCompletedAt?: Date | null, srid: number } };

export type CompleteBatchMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompleteBatchMutation = { __typename?: 'Mutation', success: boolean };

export type GetBatchesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetBatchesQuery = { __typename?: 'Query', batches: Array<{ __typename?: 'UploadBatch', id: string, key: string, status: UploadBatchStatus, createdAt: Date, numberOfAttachments: number, processingStartedAt?: Date | null, processingCompletedAt?: Date | null, srid: number, createdBy?: { __typename?: 'User', id: string, name: string, email: string, avatar?: { __typename?: 'Attachment', id: string, url: string } | null } | null }> };

export type GetBatchQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBatchQuery = { __typename?: 'Query', batch: { __typename?: 'UploadBatch', id: string, key: string, status: UploadBatchStatus, createdAt: Date, createdById?: string | null, srid: number, numberOfAttachments: number, processingStartedAt?: Date | null, processingCompletedAt?: Date | null, createdBy?: { __typename?: 'User', id: string, name: string, email: string, avatar?: { __typename?: 'Attachment', id: string, url: string } | null } | null, attachments: Array<{ __typename?: 'Attachment', id: string, url: string, s3Key: string, filename: string, contentType: string, contentLength?: any | null, byproducts: Array<{ __typename?: 'Byproduct', id: string, filename: string, type: ByproductType, contentLength?: any | null, downloadUrl: string }> }>, jobs: Array<{ __typename?: 'ProcessJob', id: string, type: ProcessJobType, status: ProcessJobStatus, inputJson: any, outputJson?: any | null, leaseUntil?: Date | null, attempts: number, isLeaf: boolean, batchId: string, parentItemId?: string | null, label?: string | null, logs?: string | null, logStream?: string | null, errorLogs?: string | null, startedAt?: Date | null, completedAt?: Date | null, estimatedCompletion?: Date | null, createdAt: Date, updatedAt: Date }> } };

export type StartBatchProcessingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  srid: Scalars['Int']['input'];
  type: ProcessJobType;
  dxfOutputVersion?: InputMaybe<Scalars['String']['input']>;
  minZoom?: InputMaybe<Scalars['Int']['input']>;
  maxZoom?: InputMaybe<Scalars['Int']['input']>;
  tileSize?: InputMaybe<Scalars['Int']['input']>;
  pointCloudAttributes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  compressImages?: InputMaybe<Scalars['Boolean']['input']>;
  generateRcs?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StartBatchProcessingMutation = { __typename?: 'Mutation', success: boolean };

export type CreateAttachmentMutationVariables = Exact<{
  project?: InputMaybe<Scalars['ID']['input']>;
  filename: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  checksumSHA256Base64?: InputMaybe<Scalars['String']['input']>;
  type: UploadType;
}>;


export type CreateAttachmentMutation = { __typename?: 'Mutation', createAttachment: { __typename?: 'CreateAttachmentResponse', uploadUrl: string, attachment: { __typename?: 'Attachment', id: string, url: string, s3Key: string, uploadId?: string | null, batchId?: string | null, filename: string, contentType: string, contentLength?: any | null, checksumSHA256Base64?: string | null, status: AttachmentStatus, createdAt: Date, updatedAt: Date, organizationId: string, projectId?: string | null } } };

export type DeleteAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['ID']['input'];
}>;


export type DeleteAttachmentMutation = { __typename?: 'Mutation', success: boolean };

export type DeleteBatchMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBatchMutation = { __typename?: 'Mutation', success: boolean };

export type ResetBatchMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResetBatchMutation = { __typename?: 'Mutation', success: boolean };

export type FeaturesQueryVariables = Exact<{
  layerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FeaturesQuery = { __typename?: 'Query', featuresByLayer: Array<{ __typename?: 'Feature', id: string, serial: number, layerId?: string | null, geometryWGS84: any, geometry: any, properties: any }> };

export type FeatureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FeatureQuery = { __typename?: 'Query', feature: { __typename?: 'Feature', id: string, serial: number, layerId?: string | null, geometryWGS84: any, geometry: any, properties: any } };

export type CreateFeatureMutationVariables = Exact<{
  input: CreateFeatureInput;
}>;


export type CreateFeatureMutation = { __typename?: 'Mutation', createFeature: { __typename?: 'Feature', id: string, serial: number, layerId?: string | null, geometryWGS84: any, geometry: any, properties: any } };

export type UpdateFeatureMutationVariables = Exact<{
  input: UpdateFeatureInput;
}>;


export type UpdateFeatureMutation = { __typename?: 'Mutation', updateFeature: { __typename?: 'Feature', id: string, serial: number, layerId?: string | null, geometryWGS84: any, geometry: any, properties: any } };

export type FeaturesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FeaturesByIdsQuery = { __typename?: 'Query', featuresByIds: Array<{ __typename?: 'Feature', id: string, serial: number, layerId?: string | null, properties: any }> };

export type UpdateFeaturesMutationVariables = Exact<{
  input: Array<UpdateFeatureInput> | UpdateFeatureInput;
}>;


export type UpdateFeaturesMutation = { __typename?: 'Mutation', updateFeatures: Array<{ __typename?: 'Feature', id: string, serial: number, layerId?: string | null, properties: any }> };

export type DeleteFeatureMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFeatureMutation = { __typename?: 'Mutation', deleteFeature: boolean };

export type DeleteFeaturesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteFeaturesMutation = { __typename?: 'Mutation', deleteFeatures: boolean };

export type SridsQueryVariables = Exact<{ [key: string]: never; }>;


export type SridsQuery = { __typename?: 'Query', srids: Array<{ __typename?: 'SRID', srid: number, name: string, projection: string }> };

export type FeaturesPaginatedQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  layerId?: InputMaybe<Scalars['ID']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<FeatureOrder>;
  limit: Scalars['Int']['input'];
  filters?: InputMaybe<Array<FeatureFilter> | FeatureFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type FeaturesPaginatedQuery = { __typename?: 'Query', featuresPaginated: { __typename?: 'FeaturePaginated', total: number, cursor?: string | null, features: Array<{ __typename?: 'Feature', id: string, serial: number, properties: any, layerId?: string | null }> } };

export type FeatureAttachmentsQueryVariables = Exact<{
  featureId: Scalars['ID']['input'];
}>;


export type FeatureAttachmentsQuery = { __typename?: 'Query', featureAttachments: Array<{ __typename?: 'FeatureAttachment', id: string, label: string, uploadedById: string, attachmentId: string, createdAt: Date, updatedAt: Date, attachment: { __typename?: 'Attachment', id: string, url: string, filename: string, contentType: string, contentLength?: any | null }, uploadedBy: { __typename?: 'User', id: string, name: string, email: string, avatar?: { __typename?: 'Attachment', url: string } | null } }> };

export type CreateFeatureAttachmentMutationVariables = Exact<{
  input: CreateFeatureAttachmentInput;
}>;


export type CreateFeatureAttachmentMutation = { __typename?: 'Mutation', createFeatureAttachment: { __typename?: 'FeatureAttachment', id: string, label: string, uploadedById: string, attachmentId: string, createdAt: Date, attachment: { __typename?: 'Attachment', id: string, url: string, filename: string, contentType: string, contentLength?: any | null } } };

export type DeleteFeatureAttachmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFeatureAttachmentMutation = { __typename?: 'Mutation', deleteFeatureAttachment: boolean };

export type DownloadFeaturesMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  layerId?: InputMaybe<Scalars['ID']['input']>;
  exportType: ExportType;
}>;


export type DownloadFeaturesMutation = { __typename?: 'Mutation', downloadFeatures: string };

export type GoogleImagesByPositionQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
}>;


export type GoogleImagesByPositionQuery = { __typename?: 'Query', images: Array<{ __typename?: 'GoogleImage', id: string, panoId: string, root: string, heading: number, roll: number, tilt: number, width: number, height: number, copyright: string, date: string, locationWGS84: any, createdAt: Date }> };

export type ImagesQueryVariables = Exact<{
  layerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ImagesQuery = { __typename?: 'Query', imagesByLayer: Array<{ __typename?: 'Image', id: string, organizationId: string, projectId: string, attachmentId?: string | null, layerId?: string | null, locationWGS84: any, location: any, groupId: number, width: number, height: number, pixelWidth: number, pixelHeight: number, focalLengthX?: number | null, focalLengthY?: number | null, principalPointX?: number | null, principalPointY?: number | null, rotationMatrix: Array<number>, rotationQuaternion: Array<number>, filename: string, cameraType?: number | null, k1?: number | null, k2?: number | null, k3?: number | null, k4?: number | null, p1?: number | null, p2?: number | null, hasCompressedVariants: boolean, smallFilename?: string | null, largeFilename?: string | null, createdAt: Date, updatedAt: Date }> };

export type LayersQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type LayersQuery = { __typename?: 'Query', layers: Array<{ __typename?: 'Layer', id: string, parentLayerId?: string | null, name: string, description?: string | null, type: LayerType, root?: string | null, metadata?: any | null, bbox?: any | null, bboxNew?: any | null, center?: any | null, isHidden: boolean, isLocked: boolean, createdAt: Date, updatedAt: Date, propertyAliases: Array<{ __typename?: 'PropertyAlias', property: string, alias: string }>, settings: { __typename?: 'LayerSettings', pointCloudMaterialColorSource: number, pointCloudMaterialColor: PointColorType, pointCloudFixedColor: string, modelIsWireframe: boolean, modelDefaultColor: string, imagePointColor: string, vectorDefaultColor: string, vectorDefaultOpacity: number, vectorIsWireframe: boolean, vectorDefaultPointSize: number, pointCloudClasses: Array<{ __typename?: 'PointCloudClassSettings', color: string, isEnabled: boolean }> } }> };

export type CreateLayerMutationVariables = Exact<{
  input: CreateLayerInput;
}>;


export type CreateLayerMutation = { __typename?: 'Mutation', createLayer: { __typename?: 'Layer', id: string } };

export type UpdateLayerMutationVariables = Exact<{
  input: UpdateLayerInput;
}>;


export type UpdateLayerMutation = { __typename?: 'Mutation', updateLayer: { __typename?: 'Layer', id: string, name: string, description?: string | null, createdAt: Date, updatedAt: Date } };

export type DeleteLayerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLayerMutation = { __typename?: 'Mutation', deleteLayer: boolean };

export type LayerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LayerQuery = { __typename?: 'Query', layer: { __typename?: 'Layer', id: string, parentLayerId?: string | null, name: string, description?: string | null, type: LayerType, root?: string | null, metadata?: any | null, bbox?: any | null, bboxNew?: any | null, center?: any | null, isHidden: boolean, isLocked: boolean, createdAt: Date, updatedAt: Date, sourceAttachment?: { __typename?: 'Attachment', batchId?: string | null, filename: string, contentLength?: any | null, createdAt: Date } | null, settings: { __typename?: 'LayerSettings', pointCloudMaterialColorSource: number, pointCloudMaterialColor: PointColorType, pointCloudFixedColor: string, modelIsWireframe: boolean, modelDefaultColor: string, imagePointColor: string, vectorDefaultColor: string, vectorDefaultOpacity: number, vectorIsWireframe: boolean, vectorDefaultPointSize: number, pointCloudClasses: Array<{ __typename?: 'PointCloudClassSettings', color: string, isEnabled: boolean }> } } };

export type UpdateLayerSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: LayerSettingsInput;
}>;


export type UpdateLayerSettingsMutation = { __typename?: 'Mutation', updateLayerSettings: boolean };

export type LayerSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LayerSettingsQuery = { __typename?: 'Query', layer: { __typename?: 'Layer', id: string, settings: { __typename?: 'LayerSettings', pointCloudMaterialColorSource: number, pointCloudMaterialColor: PointColorType, pointCloudFixedColor: string, modelIsWireframe: boolean, modelDefaultColor: string, imagePointColor: string, vectorDefaultColor: string, vectorDefaultOpacity: number, vectorIsWireframe: boolean, vectorDefaultPointSize: number, pointCloudClasses: Array<{ __typename?: 'PointCloudClassSettings', color: string, isEnabled: boolean }> } } };

export type LayerPropertiesQueryVariables = Exact<{
  layerId: Scalars['ID']['input'];
}>;


export type LayerPropertiesQuery = { __typename?: 'Query', layerProperties: Array<string> };

export type LayerPropertyValuesQueryVariables = Exact<{
  layerId: Scalars['ID']['input'];
}>;


export type LayerPropertyValuesQuery = { __typename?: 'Query', layerPropertyValues: Array<{ __typename?: 'PropertyValues', property: string, values: Array<string> }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, firstName: string, lastName: string, name: string, email: string, mobileNumber?: string | null, avatarId?: string | null, onboardingSurveyCompleted: boolean, twoFactorEnabled: boolean, twoFactorType?: TwoFactorType | null, theme: ThemePreference, avatar?: { __typename?: 'Attachment', url: string } | null, featurebaseUser?: { __typename?: 'FeaturebaseUser', organization: string, email?: string | null, name?: string | null, userId: string, profilePicture?: string | null, featurebaseJwt?: string | null } | null, viewerSettings: { __typename?: 'UserViewerSettings', pointCloudPointSizeType: PointCloudPointSizeType, pointCloudPointSize: number, pointCloudPointBudget: number, showLayerSource: boolean, showLayerUnderType: boolean, showImagePOIs: boolean, showPointCloudBoundingBoxes: boolean, googleStreetViewPoiColor?: string | null } } };

export type UserPasskeysQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPasskeysQuery = { __typename?: 'Query', userPasskeys: Array<{ __typename?: 'UserPasskey', id: string, name: string, createdAt: Date, lastUsedAt?: Date | null }> };

export type RenamePasskeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenamePasskeyMutation = { __typename?: 'Mutation', renamePasskey: boolean };

export type DeletePasskeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePasskeyMutation = { __typename?: 'Mutation', deletePasskey: boolean };

export type MeUserSessionsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type MeUserSessionsQuery = { __typename?: 'Query', userSessions: Array<{ __typename?: 'UserSession', id: string, createdAt: Date, expiresAt: Date, lastUsedAt: Date, revokedAt?: Date | null, ipHash: string, loginMethod: UserSessionMethod, country?: string | null, userAgent?: string | null, status: UserSessionStatus }> };

export type MyOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyOrganizationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: string, name: string, slug?: string | null, role?: UserOrganizationRole | null, storageUsedBytes: any, storageLimitBytes: any, logo?: { __typename?: 'Attachment', url: string } | null, subscription: { __typename?: 'SubscriptionInfo', tier: SubscriptionTier, billingStatus: BillingStatus, trialEndsAt?: Date | null } }> };

export type OrganizationUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, name: string, email: string, role?: UserOrganizationRole | null, joinedAt?: Date | null, createdAt: Date, avatar?: { __typename?: 'Attachment', url: string } | null }> };

export type RemoveUserFromOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveUserFromOrganizationMutation = { __typename?: 'Mutation', removeUserFromOrganization: boolean };

export type UpdateUserRoleInOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  role: UserOrganizationRole;
}>;


export type UpdateUserRoleInOrganizationMutation = { __typename?: 'Mutation', updateUserRoleInOrganization: boolean };

export type InviteUserToOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  role: UserOrganizationRole;
  firstname: Scalars['String']['input'];
  lastname?: InputMaybe<Scalars['String']['input']>;
}>;


export type InviteUserToOrganizationMutation = { __typename?: 'Mutation', inviteUserToOrganization: boolean };

export type InviteUsersToOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  invitees: Array<InviteUserInput> | InviteUserInput;
}>;


export type InviteUsersToOrganizationMutation = { __typename?: 'Mutation', inviteUsersToOrganization: boolean };

export type OrganizationInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationInvitationsQuery = { __typename?: 'Query', invitations: Array<{ __typename?: 'UserInvitation', id: string, email: string, role: UserOrganizationRole, createdAt: Date, expiresAt: Date, acceptedAt?: Date | null }> };

export type RevokeInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RevokeInvitationMutation = { __typename?: 'Mutation', revokeInvitation: boolean };

export type AcceptInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'UserInvitationResult', success: boolean, error?: string | null, organization?: { __typename?: 'Organization', id: string, name: string } | null } };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, name: string, logo?: { __typename?: 'Attachment', url: string } | null } };

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization: boolean };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string, name: string, slug?: string | null, role?: UserOrganizationRole | null } };

export type SlugAvailableQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type SlugAvailableQuery = { __typename?: 'Query', slugAvailable: boolean };

export type InviteOnboardingUsersMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  invitees: Array<OnboardingInviteInput> | OnboardingInviteInput;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type InviteOnboardingUsersMutation = { __typename?: 'Mutation', inviteOnboardingUsers: boolean };

export type MyProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', id: string, name: string, srid: number, organizationId: string, storageUsedBytes: any }> };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, name: string, description?: string | null, srid: number, organizationId: string, initialPosition?: any | null, initialAngle: number } };

export type GetSharedProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSharedProjectQuery = { __typename?: 'Query', sharedProject: { __typename?: 'Project', id: string, name: string, srid: number, organizationId: string, initialPosition?: any | null, initialAngle: number, organization?: { __typename?: 'Organization', name: string, slug?: string | null, logo?: { __typename?: 'Attachment', url: string } | null } | null } };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string, name: string, srid: number } };

export type GetProjectJobsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectJobsQuery = { __typename?: 'Query', jobs: Array<{ __typename?: 'ProcessJob', id: string, type: ProcessJobType, status: ProcessJobStatus, inputJson: any, outputJson?: any | null, logs?: string | null, errorLogs?: string | null, startedAt?: Date | null, completedAt?: Date | null, estimatedCompletion?: Date | null, leaseUntil?: Date | null, attempts: number, isLeaf: boolean, batchId: string, parentItemId?: string | null, createdAt: Date, updatedAt: Date }> };

export type GetProjectJobsByBatchQueryVariables = Exact<{
  batchId: Scalars['ID']['input'];
}>;


export type GetProjectJobsByBatchQuery = { __typename?: 'Query', jobs: Array<{ __typename?: 'ProcessJob', id: string, type: ProcessJobType, status: ProcessJobStatus, inputJson: any, outputJson?: any | null, logs?: string | null, errorLogs?: string | null, startedAt?: Date | null, completedAt?: Date | null, estimatedCompletion?: Date | null, leaseUntil?: Date | null, attempts: number, isLeaf: boolean, batchId: string, parentItemId?: string | null, createdAt: Date, updatedAt: Date }> };

export type GetProjectLinksQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectLinksQuery = { __typename?: 'Query', projectLinks: Array<{ __typename?: 'ProjectLink', id: string, projectId: string, name?: string | null, token: string, hasPassword: boolean, expiresAt: Date, createdAt: Date, createdById: string, status: ProjectLinkStatus, createdBy?: { __typename?: 'User', id: string, name: string, email: string, avatar?: { __typename?: 'Attachment', url: string } | null } | null }> };

export type GetAllProjectLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectLinksQuery = { __typename?: 'Query', allProjectLinks: Array<{ __typename?: 'ProjectLink', id: string, projectId: string, name?: string | null, token: string, hasPassword: boolean, expiresAt: Date, createdAt: Date, createdById: string, status: ProjectLinkStatus, project?: { __typename?: 'Project', id: string, name: string } | null, createdBy?: { __typename?: 'User', id: string, name: string, email: string, avatar?: { __typename?: 'Attachment', url: string } | null } | null }> };

export type OrganizationWithSubscriptionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationWithSubscriptionQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, name: string, storageUsedBytes: any, storageLimitBytes: any, subscription: { __typename?: 'SubscriptionInfo', tier: SubscriptionTier, billingStatus: BillingStatus, collectionMethod?: CollectionMethod | null, billingInterval?: BillingInterval | null, storageBlocks: number, storageLimitBytes: any, currentPeriodEnd?: Date | null, cancelAtPeriodEnd: boolean, cancelAt?: Date | null, scheduledTier?: SubscriptionTier | null, scheduledStorageBlocks?: number | null, scheduledChangeAt?: Date | null, trialEndsAt?: Date | null } } };

export type SubscriptionDetailsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type SubscriptionDetailsQuery = { __typename?: 'Query', subscriptionDetails: { __typename?: 'SubscriptionDetails', info: { __typename?: 'SubscriptionInfo', tier: SubscriptionTier, billingStatus: BillingStatus, collectionMethod?: CollectionMethod | null, billingInterval?: BillingInterval | null, storageBlocks: number, storageLimitBytes: any, currentPeriodEnd?: Date | null, cancelAtPeriodEnd: boolean, cancelAt?: Date | null, scheduledTier?: SubscriptionTier | null, scheduledStorageBlocks?: number | null, scheduledChangeAt?: Date | null, trialEndsAt?: Date | null }, invoices: Array<{ __typename?: 'Invoice', id: string, number?: string | null, status: string, amountDue: number, amountPaid: number, currency: string, created: Date, dueDate?: Date | null, hostedInvoiceUrl?: string | null, pdfUrl?: string | null }>, nextInvoicePreview?: { __typename?: 'InvoicePreview', amountDue: number, currency: string, periodStart: Date, periodEnd: Date, lines: Array<{ __typename?: 'InvoiceLineItem', description: string, amount: number, quantity?: number | null }> } | null, discount?: { __typename?: 'DiscountInfo', promoCodeId?: string | null, couponId: string, name?: string | null, percentOff?: number | null, amountOff?: number | null, expiresAt?: Date | null } | null } };

export type ValidatePromoCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ValidatePromoCodeQuery = { __typename?: 'Query', validatePromoCode: { __typename?: 'PromoCodeValidation', valid: boolean, name?: string | null, percentOff?: number | null, amountOff?: number | null } };

export type SubscriptionPricingQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionPricingQuery = { __typename?: 'Query', subscriptionPricing: { __typename?: 'PricingInfo', currency: string, tiers: Array<{ __typename?: 'TierPricing', tier: SubscriptionTier, name: string, description: string, storage: { __typename?: 'StoragePricing', monthly: Array<{ __typename?: 'PricingTier', upTo?: number | null, unitAmount: number, unitAmountDecimal: string }>, annual: Array<{ __typename?: 'PricingTier', upTo?: number | null, unitAmount: number, unitAmountDecimal: string }> } }> } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const UpdateProjectDocument = new TypedDocumentString(`
    mutation UpdateProject($input: UpdateProjectInput!) {
  updateProject(input: $input) {
    id
    name
    description
    srid
  }
}
    `) as unknown as TypedDocumentString<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const CreateProjectLinkDocument = new TypedDocumentString(`
    mutation CreateProjectLink($projectId: ID!, $expiresAt: DateTime!, $name: String!, $password: String) {
  createProjectLink(
    projectId: $projectId
    expiresAt: $expiresAt
    name: $name
    password: $password
  ) {
    id
    projectId
    token
    hasPassword
    expiresAt
    createdAt
    createdById
    createdBy {
      id
      name
      email
    }
  }
}
    `) as unknown as TypedDocumentString<CreateProjectLinkMutation, CreateProjectLinkMutationVariables>;
export const UpdateProjectLinkPasswordDocument = new TypedDocumentString(`
    mutation UpdateProjectLinkPassword($id: ID!, $password: String) {
  updateProjectLinkPassword(id: $id, password: $password) {
    id
    hasPassword
  }
}
    `) as unknown as TypedDocumentString<UpdateProjectLinkPasswordMutation, UpdateProjectLinkPasswordMutationVariables>;
export const DeleteProjectLinkDocument = new TypedDocumentString(`
    mutation DeleteProjectLink($id: ID!) {
  deleteProjectLink(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteProjectLinkMutation, DeleteProjectLinkMutationVariables>;
export const DeleteProjectDocument = new TypedDocumentString(`
    mutation DeleteProject($id: ID!) {
  deleteProject(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const CreateSubscriptionDocument = new TypedDocumentString(`
    mutation CreateSubscription($input: CreateSubscriptionInput!) {
  createSubscription(input: $input) {
    type
    url
  }
}
    `) as unknown as TypedDocumentString<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const UpdateSubscriptionStorageDocument = new TypedDocumentString(`
    mutation UpdateSubscriptionStorage($input: UpdateStorageInput!) {
  updateSubscriptionStorage(input: $input)
}
    `) as unknown as TypedDocumentString<UpdateSubscriptionStorageMutation, UpdateSubscriptionStorageMutationVariables>;
export const ChangeSubscriptionTierDocument = new TypedDocumentString(`
    mutation ChangeSubscriptionTier($input: ChangeTierInput!) {
  changeSubscriptionTier(input: $input)
}
    `) as unknown as TypedDocumentString<ChangeSubscriptionTierMutation, ChangeSubscriptionTierMutationVariables>;
export const CancelSubscriptionDocument = new TypedDocumentString(`
    mutation CancelSubscription($organizationId: ID!) {
  cancelSubscription(organizationId: $organizationId)
}
    `) as unknown as TypedDocumentString<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const ReactivateSubscriptionDocument = new TypedDocumentString(`
    mutation ReactivateSubscription($organizationId: ID!) {
  reactivateSubscription(organizationId: $organizationId)
}
    `) as unknown as TypedDocumentString<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>;
export const ApplySubscriptionDiscountDocument = new TypedDocumentString(`
    mutation ApplySubscriptionDiscount($input: ApplyDiscountInput!) {
  applySubscriptionDiscount(input: $input)
}
    `) as unknown as TypedDocumentString<ApplySubscriptionDiscountMutation, ApplySubscriptionDiscountMutationVariables>;
export const RemoveSubscriptionDiscountDocument = new TypedDocumentString(`
    mutation RemoveSubscriptionDiscount($organizationId: ID!) {
  removeSubscriptionDiscount(organizationId: $organizationId)
}
    `) as unknown as TypedDocumentString<RemoveSubscriptionDiscountMutation, RemoveSubscriptionDiscountMutationVariables>;
export const CreateBillingPortalSessionDocument = new TypedDocumentString(`
    mutation CreateBillingPortalSession($organizationId: ID!, $returnUrl: String!) {
  createBillingPortalSession(
    organizationId: $organizationId
    returnUrl: $returnUrl
  )
}
    `) as unknown as TypedDocumentString<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>;
export const UpdateUserDocument = new TypedDocumentString(`
    mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
  updateUser(id: $id, input: $input) {
    id
    name
    mobileNumber
    avatar {
      id
      url
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdatePasswordDocument = new TypedDocumentString(`
    mutation UpdatePassword($id: ID!, $input: UpdatePasswordInput!) {
  updatePassword(id: $id, input: $input)
}
    `) as unknown as TypedDocumentString<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const DeleteUserDocument = new TypedDocumentString(`
    mutation DeleteUser($id: ID!, $password: String!) {
  deleteUser(id: $id, password: $password)
}
    `) as unknown as TypedDocumentString<DeleteUserMutation, DeleteUserMutationVariables>;
export const UpdateEmailDocument = new TypedDocumentString(`
    mutation UpdateEmail($id: ID!, $email: String!) {
  updateEmail(id: $id, email: $email)
}
    `) as unknown as TypedDocumentString<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const RevokeSessionDocument = new TypedDocumentString(`
    mutation RevokeSession($sessionId: ID!) {
  revokeSession(sessionId: $sessionId)
}
    `) as unknown as TypedDocumentString<RevokeSessionMutation, RevokeSessionMutationVariables>;
export const UpdateThemeDocument = new TypedDocumentString(`
    mutation UpdateTheme($theme: ThemePreference!) {
  updateTheme(theme: $theme)
}
    `) as unknown as TypedDocumentString<UpdateThemeMutation, UpdateThemeMutationVariables>;
export const UpdateViewerSettingsDocument = new TypedDocumentString(`
    mutation UpdateViewerSettings($input: ViewerSettingsInput!) {
  updateViewerSettings(input: $input)
}
    `) as unknown as TypedDocumentString<UpdateViewerSettingsMutation, UpdateViewerSettingsMutationVariables>;
export const SaveOnboardingSurveyDocument = new TypedDocumentString(`
    mutation SaveOnboardingSurvey($data: JSON!) {
  saveOnboardingSurvey(data: $data)
}
    `) as unknown as TypedDocumentString<SaveOnboardingSurveyMutation, SaveOnboardingSurveyMutationVariables>;
export const SetupTwoFactorDocument = new TypedDocumentString(`
    mutation SetupTwoFactor($mobileNumber: String!) {
  setupTwoFactor(mobileNumber: $mobileNumber) {
    secret
  }
}
    `) as unknown as TypedDocumentString<SetupTwoFactorMutation, SetupTwoFactorMutationVariables>;
export const VerifyTwoFactorSetupDocument = new TypedDocumentString(`
    mutation VerifyTwoFactorSetup($secret: String!, $code: String!) {
  verifyTwoFactorSetup(secret: $secret, code: $code)
}
    `) as unknown as TypedDocumentString<VerifyTwoFactorSetupMutation, VerifyTwoFactorSetupMutationVariables>;
export const SetupAuthenticatorTwoFactorDocument = new TypedDocumentString(`
    mutation SetupAuthenticatorTwoFactor {
  setupAuthenticatorTwoFactor {
    secret
    otpauthUri
  }
}
    `) as unknown as TypedDocumentString<SetupAuthenticatorTwoFactorMutation, SetupAuthenticatorTwoFactorMutationVariables>;
export const VerifyAuthenticatorTwoFactorSetupDocument = new TypedDocumentString(`
    mutation VerifyAuthenticatorTwoFactorSetup($secret: String!, $code: String!) {
  verifyAuthenticatorTwoFactorSetup(secret: $secret, code: $code)
}
    `) as unknown as TypedDocumentString<VerifyAuthenticatorTwoFactorSetupMutation, VerifyAuthenticatorTwoFactorSetupMutationVariables>;
export const DisableTwoFactorDocument = new TypedDocumentString(`
    mutation DisableTwoFactor($secret: String!, $code: String!) {
  disableTwoFactor(secret: $secret, code: $code)
}
    `) as unknown as TypedDocumentString<DisableTwoFactorMutation, DisableTwoFactorMutationVariables>;
export const DisableAuthenticatorTwoFactorDocument = new TypedDocumentString(`
    mutation DisableAuthenticatorTwoFactor($code: String!) {
  disableAuthenticatorTwoFactor(code: $code)
}
    `) as unknown as TypedDocumentString<DisableAuthenticatorTwoFactorMutation, DisableAuthenticatorTwoFactorMutationVariables>;
export const GetAttachmentsDocument = new TypedDocumentString(`
    query GetAttachments {
  attachments {
    id
    url
    s3Key
    uploadId
    filename
    contentType
    contentLength
    checksumSHA256Base64
    status
    createdAt
    updatedAt
    deletedAt
    organizationId
    projectId
  }
}
    `) as unknown as TypedDocumentString<GetAttachmentsQuery, GetAttachmentsQueryVariables>;
export const GetAttachmentsByBatchDocument = new TypedDocumentString(`
    query GetAttachmentsByBatch($batchId: ID!) {
  attachmentsByBatch(batchId: $batchId) {
    id
    url
    s3Key
    uploadId
    filename
    contentType
    contentLength
    checksumSHA256Base64
    status
    createdAt
    updatedAt
    organizationId
    projectId
  }
}
    `) as unknown as TypedDocumentString<GetAttachmentsByBatchQuery, GetAttachmentsByBatchQueryVariables>;
export const StartUploadDocument = new TypedDocumentString(`
    mutation StartUpload($project: ID!, $filename: String!, $contentType: String!, $checksumSHA256Base64: String, $batch: ID) {
  attachment: startUpload(
    project: $project
    filename: $filename
    contentType: $contentType
    checksumSHA256Base64: $checksumSHA256Base64
    batch: $batch
  ) {
    id
    url
    s3Key
    uploadId
    batchId
    filename
    contentType
    contentLength
    checksumSHA256Base64
    status
    createdAt
    updatedAt
    organizationId
    projectId
  }
}
    `) as unknown as TypedDocumentString<StartUploadMutation, StartUploadMutationVariables>;
export const StartUploadBatchDocument = new TypedDocumentString(`
    mutation StartUploadBatch($project: ID!, $numberOfAttachments: Int!) {
  batch: startBatch(project: $project, numberOfAttachments: $numberOfAttachments) {
    id
  }
}
    `) as unknown as TypedDocumentString<StartUploadBatchMutation, StartUploadBatchMutationVariables>;
export const CompleteUploadBatchDocument = new TypedDocumentString(`
    mutation CompleteUploadBatch($id: ID!) {
  success: completeBatch(id: $id)
}
    `) as unknown as TypedDocumentString<CompleteUploadBatchMutation, CompleteUploadBatchMutationVariables>;
export const UploadPartDocument = new TypedDocumentString(`
    mutation UploadPart($attachmentId: ID!, $partNumber: Int!, $contentLength: Int!, $checksumSHA256Base64: String!) {
  url: uploadPart(
    attachmentId: $attachmentId
    partNumber: $partNumber
    contentLength: $contentLength
    checksumSHA256Base64: $checksumSHA256Base64
  )
}
    `) as unknown as TypedDocumentString<UploadPartMutation, UploadPartMutationVariables>;
export const CompleteUploadDocument = new TypedDocumentString(`
    mutation CompleteUpload($attachmentId: ID!, $parts: [S3CompletedPart!]!) {
  attachment: completeUpload(attachmentId: $attachmentId, parts: $parts) {
    id
    url
    s3Key
    uploadId
    filename
    contentType
    contentLength
    checksumSHA256Base64
    status
    createdAt
    updatedAt
    organizationId
    projectId
  }
}
    `) as unknown as TypedDocumentString<CompleteUploadMutation, CompleteUploadMutationVariables>;
export const AbortUploadDocument = new TypedDocumentString(`
    mutation AbortUpload($attachmentId: ID!) {
  success: abortUpload(attachmentId: $attachmentId)
}
    `) as unknown as TypedDocumentString<AbortUploadMutation, AbortUploadMutationVariables>;
export const StartBatchDocument = new TypedDocumentString(`
    mutation StartBatch($project: ID!, $numberOfAttachments: Int!) {
  batch: startBatch(project: $project, numberOfAttachments: $numberOfAttachments) {
    id
    status
    createdAt
    createdById
    numberOfAttachments
    processingStartedAt
    processingCompletedAt
    srid
  }
}
    `) as unknown as TypedDocumentString<StartBatchMutation, StartBatchMutationVariables>;
export const CompleteBatchDocument = new TypedDocumentString(`
    mutation CompleteBatch($id: ID!) {
  success: completeBatch(id: $id)
}
    `) as unknown as TypedDocumentString<CompleteBatchMutation, CompleteBatchMutationVariables>;
export const GetBatchesDocument = new TypedDocumentString(`
    query GetBatches($projectId: ID!) {
  batches(projectId: $projectId) {
    id
    key
    status
    createdAt
    numberOfAttachments
    processingStartedAt
    processingCompletedAt
    srid
    createdBy {
      id
      name
      email
      avatar {
        id
        url
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetBatchesQuery, GetBatchesQueryVariables>;
export const GetBatchDocument = new TypedDocumentString(`
    query GetBatch($id: ID!) {
  batch(id: $id) {
    id
    key
    status
    createdAt
    createdById
    createdBy {
      id
      name
      email
      avatar {
        id
        url
      }
    }
    srid
    numberOfAttachments
    processingStartedAt
    processingCompletedAt
    attachments {
      id
      url
      s3Key
      filename
      contentType
      contentLength
      byproducts {
        id
        filename
        type
        contentLength
        downloadUrl
      }
    }
    jobs {
      id
      type
      status
      inputJson
      outputJson
      leaseUntil
      attempts
      isLeaf
      batchId
      parentItemId
      label
      logs
      logStream
      errorLogs
      startedAt
      completedAt
      estimatedCompletion
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<GetBatchQuery, GetBatchQueryVariables>;
export const StartBatchProcessingDocument = new TypedDocumentString(`
    mutation StartBatchProcessing($id: ID!, $srid: Int!, $type: ProcessJobType!, $dxfOutputVersion: String, $minZoom: Int, $maxZoom: Int, $tileSize: Int, $pointCloudAttributes: [String!], $compressImages: Boolean, $generateRcs: Boolean) {
  success: startBatchProcessing(
    id: $id
    srid: $srid
    type: $type
    dxfOutputVersion: $dxfOutputVersion
    minZoom: $minZoom
    maxZoom: $maxZoom
    tileSize: $tileSize
    pointCloudAttributes: $pointCloudAttributes
    compressImages: $compressImages
    generateRcs: $generateRcs
  )
}
    `) as unknown as TypedDocumentString<StartBatchProcessingMutation, StartBatchProcessingMutationVariables>;
export const CreateAttachmentDocument = new TypedDocumentString(`
    mutation CreateAttachment($project: ID, $filename: String!, $contentType: String!, $checksumSHA256Base64: String, $type: UploadType!) {
  createAttachment(
    project: $project
    filename: $filename
    contentType: $contentType
    checksumSHA256Base64: $checksumSHA256Base64
    type: $type
  ) {
    attachment {
      id
      url
      s3Key
      uploadId
      batchId
      filename
      contentType
      contentLength
      checksumSHA256Base64
      status
      createdAt
      updatedAt
      organizationId
      projectId
    }
    uploadUrl
  }
}
    `) as unknown as TypedDocumentString<CreateAttachmentMutation, CreateAttachmentMutationVariables>;
export const DeleteAttachmentDocument = new TypedDocumentString(`
    mutation DeleteAttachment($attachmentId: ID!) {
  success: deleteAttachment(attachmentId: $attachmentId)
}
    `) as unknown as TypedDocumentString<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;
export const DeleteBatchDocument = new TypedDocumentString(`
    mutation DeleteBatch($id: ID!) {
  success: deleteBatch(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteBatchMutation, DeleteBatchMutationVariables>;
export const ResetBatchDocument = new TypedDocumentString(`
    mutation ResetBatch($id: ID!) {
  success: resetBatch(id: $id)
}
    `) as unknown as TypedDocumentString<ResetBatchMutation, ResetBatchMutationVariables>;
export const FeaturesDocument = new TypedDocumentString(`
    query features($layerIds: [ID!]!) {
  featuresByLayer(layerIds: $layerIds) {
    id
    serial
    layerId
    geometryWGS84
    geometry
    properties
  }
}
    `) as unknown as TypedDocumentString<FeaturesQuery, FeaturesQueryVariables>;
export const FeatureDocument = new TypedDocumentString(`
    query Feature($id: ID!) {
  feature(id: $id) {
    id
    serial
    layerId
    geometryWGS84
    geometry
    properties
  }
}
    `) as unknown as TypedDocumentString<FeatureQuery, FeatureQueryVariables>;
export const CreateFeatureDocument = new TypedDocumentString(`
    mutation CreateFeature($input: CreateFeatureInput!) {
  createFeature(input: $input) {
    id
    serial
    layerId
    geometryWGS84
    geometry
    properties
  }
}
    `) as unknown as TypedDocumentString<CreateFeatureMutation, CreateFeatureMutationVariables>;
export const UpdateFeatureDocument = new TypedDocumentString(`
    mutation UpdateFeature($input: UpdateFeatureInput!) {
  updateFeature(input: $input) {
    id
    serial
    layerId
    geometryWGS84
    geometry
    properties
  }
}
    `) as unknown as TypedDocumentString<UpdateFeatureMutation, UpdateFeatureMutationVariables>;
export const FeaturesByIdsDocument = new TypedDocumentString(`
    query FeaturesByIds($ids: [ID!]!) {
  featuresByIds(ids: $ids) {
    id
    serial
    layerId
    properties
  }
}
    `) as unknown as TypedDocumentString<FeaturesByIdsQuery, FeaturesByIdsQueryVariables>;
export const UpdateFeaturesDocument = new TypedDocumentString(`
    mutation UpdateFeatures($input: [UpdateFeatureInput!]!) {
  updateFeatures(input: $input) {
    id
    serial
    layerId
    properties
  }
}
    `) as unknown as TypedDocumentString<UpdateFeaturesMutation, UpdateFeaturesMutationVariables>;
export const DeleteFeatureDocument = new TypedDocumentString(`
    mutation DeleteFeature($id: ID!) {
  deleteFeature(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteFeatureMutation, DeleteFeatureMutationVariables>;
export const DeleteFeaturesDocument = new TypedDocumentString(`
    mutation DeleteFeatures($ids: [ID!]!) {
  deleteFeatures(ids: $ids)
}
    `) as unknown as TypedDocumentString<DeleteFeaturesMutation, DeleteFeaturesMutationVariables>;
export const SridsDocument = new TypedDocumentString(`
    query Srids {
  srids {
    srid
    name
    projection
  }
}
    `) as unknown as TypedDocumentString<SridsQuery, SridsQueryVariables>;
export const FeaturesPaginatedDocument = new TypedDocumentString(`
    query featuresPaginated($projectId: ID!, $layerId: ID, $cursor: String, $orderBy: FeatureOrder, $limit: Int!, $filters: [FeatureFilter!], $query: String) {
  featuresPaginated(
    limit: $limit
    projectId: $projectId
    layerId: $layerId
    cursor: $cursor
    orderBy: $orderBy
    filters: $filters
    query: $query
  ) {
    features {
      id
      serial
      properties
      layerId
    }
    total
    cursor
  }
}
    `) as unknown as TypedDocumentString<FeaturesPaginatedQuery, FeaturesPaginatedQueryVariables>;
export const FeatureAttachmentsDocument = new TypedDocumentString(`
    query FeatureAttachments($featureId: ID!) {
  featureAttachments(featureId: $featureId) {
    id
    label
    uploadedById
    attachmentId
    attachment {
      id
      url
      filename
      contentType
      contentLength
    }
    uploadedBy {
      id
      name
      email
      avatar {
        url
      }
    }
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<FeatureAttachmentsQuery, FeatureAttachmentsQueryVariables>;
export const CreateFeatureAttachmentDocument = new TypedDocumentString(`
    mutation CreateFeatureAttachment($input: CreateFeatureAttachmentInput!) {
  createFeatureAttachment(input: $input) {
    id
    label
    uploadedById
    attachmentId
    attachment {
      id
      url
      filename
      contentType
      contentLength
    }
    createdAt
  }
}
    `) as unknown as TypedDocumentString<CreateFeatureAttachmentMutation, CreateFeatureAttachmentMutationVariables>;
export const DeleteFeatureAttachmentDocument = new TypedDocumentString(`
    mutation DeleteFeatureAttachment($id: ID!) {
  deleteFeatureAttachment(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteFeatureAttachmentMutation, DeleteFeatureAttachmentMutationVariables>;
export const DownloadFeaturesDocument = new TypedDocumentString(`
    mutation DownloadFeatures($ids: [ID!], $layerId: ID, $exportType: ExportType!) {
  downloadFeatures(ids: $ids, layerId: $layerId, exportType: $exportType)
}
    `) as unknown as TypedDocumentString<DownloadFeaturesMutation, DownloadFeaturesMutationVariables>;
export const GoogleImagesByPositionDocument = new TypedDocumentString(`
    query GoogleImagesByPosition($lat: Float!, $lng: Float!) {
  images: googleImagesByPosition(lat: $lat, lng: $lng) {
    id
    panoId
    root
    heading
    roll
    tilt
    width
    height
    copyright
    date
    locationWGS84
    createdAt
  }
}
    `) as unknown as TypedDocumentString<GoogleImagesByPositionQuery, GoogleImagesByPositionQueryVariables>;
export const ImagesDocument = new TypedDocumentString(`
    query images($layerIds: [ID!]!) {
  imagesByLayer(layerIds: $layerIds) {
    id
    organizationId
    projectId
    attachmentId
    layerId
    locationWGS84
    location
    groupId
    width
    height
    pixelWidth
    pixelHeight
    focalLengthX
    focalLengthY
    principalPointX
    principalPointY
    rotationMatrix
    rotationQuaternion
    filename
    cameraType
    k1
    k2
    k3
    k4
    p1
    p2
    hasCompressedVariants
    smallFilename
    largeFilename
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<ImagesQuery, ImagesQueryVariables>;
export const LayersDocument = new TypedDocumentString(`
    query Layers($projectId: ID!) {
  layers(projectId: $projectId) {
    id
    parentLayerId
    name
    description
    type
    root
    metadata
    bbox
    bboxNew
    center
    isHidden
    isLocked
    propertyAliases {
      property
      alias
    }
    createdAt
    updatedAt
    settings {
      pointCloudMaterialColorSource
      pointCloudMaterialColor
      pointCloudFixedColor
      modelIsWireframe
      modelDefaultColor
      pointCloudClasses {
        color
        isEnabled
      }
      imagePointColor
      vectorDefaultColor
      vectorDefaultOpacity
      vectorIsWireframe
      vectorDefaultPointSize
    }
  }
}
    `) as unknown as TypedDocumentString<LayersQuery, LayersQueryVariables>;
export const CreateLayerDocument = new TypedDocumentString(`
    mutation CreateLayer($input: CreateLayerInput!) {
  createLayer(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateLayerMutation, CreateLayerMutationVariables>;
export const UpdateLayerDocument = new TypedDocumentString(`
    mutation UpdateLayer($input: UpdateLayerInput!) {
  updateLayer(input: $input) {
    id
    name
    description
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<UpdateLayerMutation, UpdateLayerMutationVariables>;
export const DeleteLayerDocument = new TypedDocumentString(`
    mutation DeleteLayer($id: ID!) {
  deleteLayer(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteLayerMutation, DeleteLayerMutationVariables>;
export const LayerDocument = new TypedDocumentString(`
    query Layer($id: ID!) {
  layer(id: $id) {
    id
    parentLayerId
    name
    description
    type
    root
    metadata
    bbox
    bboxNew
    center
    isHidden
    isLocked
    createdAt
    updatedAt
    sourceAttachment {
      batchId
      filename
      contentLength
      createdAt
    }
    settings {
      pointCloudMaterialColorSource
      pointCloudMaterialColor
      pointCloudFixedColor
      modelIsWireframe
      modelDefaultColor
      pointCloudClasses {
        color
        isEnabled
      }
      imagePointColor
      vectorDefaultColor
      vectorDefaultOpacity
      vectorIsWireframe
      vectorDefaultPointSize
    }
  }
}
    `) as unknown as TypedDocumentString<LayerQuery, LayerQueryVariables>;
export const UpdateLayerSettingsDocument = new TypedDocumentString(`
    mutation UpdateLayerSettings($id: ID!, $input: LayerSettingsInput!) {
  updateLayerSettings(id: $id, input: $input)
}
    `) as unknown as TypedDocumentString<UpdateLayerSettingsMutation, UpdateLayerSettingsMutationVariables>;
export const LayerSettingsDocument = new TypedDocumentString(`
    query LayerSettings($id: ID!) {
  layer(id: $id) {
    id
    settings {
      pointCloudMaterialColorSource
      pointCloudMaterialColor
      pointCloudFixedColor
      modelIsWireframe
      modelDefaultColor
      pointCloudClasses {
        color
        isEnabled
      }
      imagePointColor
      vectorDefaultColor
      vectorDefaultOpacity
      vectorIsWireframe
      vectorDefaultPointSize
    }
  }
}
    `) as unknown as TypedDocumentString<LayerSettingsQuery, LayerSettingsQueryVariables>;
export const LayerPropertiesDocument = new TypedDocumentString(`
    query LayerProperties($layerId: ID!) {
  layerProperties(layerId: $layerId)
}
    `) as unknown as TypedDocumentString<LayerPropertiesQuery, LayerPropertiesQueryVariables>;
export const LayerPropertyValuesDocument = new TypedDocumentString(`
    query LayerPropertyValues($layerId: ID!) {
  layerPropertyValues(layerId: $layerId) {
    property
    values
  }
}
    `) as unknown as TypedDocumentString<LayerPropertyValuesQuery, LayerPropertyValuesQueryVariables>;
export const MeDocument = new TypedDocumentString(`
    query Me {
  me {
    id
    firstName
    lastName
    name
    email
    mobileNumber
    avatarId
    onboardingSurveyCompleted
    twoFactorEnabled
    twoFactorType
    theme
    avatar {
      url
    }
    featurebaseUser {
      organization
      email
      name
      userId
      profilePicture
      featurebaseJwt
    }
    viewerSettings {
      pointCloudPointSizeType
      pointCloudPointSize
      pointCloudPointBudget
      showLayerSource
      showLayerUnderType
      showImagePOIs
      showPointCloudBoundingBoxes
      googleStreetViewPoiColor
    }
  }
}
    `) as unknown as TypedDocumentString<MeQuery, MeQueryVariables>;
export const UserPasskeysDocument = new TypedDocumentString(`
    query UserPasskeys {
  userPasskeys {
    id
    name
    createdAt
    lastUsedAt
  }
}
    `) as unknown as TypedDocumentString<UserPasskeysQuery, UserPasskeysQueryVariables>;
export const RenamePasskeyDocument = new TypedDocumentString(`
    mutation RenamePasskey($id: ID!, $name: String!) {
  renamePasskey(id: $id, name: $name)
}
    `) as unknown as TypedDocumentString<RenamePasskeyMutation, RenamePasskeyMutationVariables>;
export const DeletePasskeyDocument = new TypedDocumentString(`
    mutation DeletePasskey($id: ID!) {
  deletePasskey(id: $id)
}
    `) as unknown as TypedDocumentString<DeletePasskeyMutation, DeletePasskeyMutationVariables>;
export const MeUserSessionsDocument = new TypedDocumentString(`
    query MeUserSessions($userId: ID!) {
  userSessions(userId: $userId) {
    id
    createdAt
    expiresAt
    lastUsedAt
    revokedAt
    ipHash
    loginMethod
    country
    userAgent
    status
  }
}
    `) as unknown as TypedDocumentString<MeUserSessionsQuery, MeUserSessionsQueryVariables>;
export const MyOrganizationsDocument = new TypedDocumentString(`
    query MyOrganizations {
  organizations {
    id
    name
    slug
    role
    logo {
      url
    }
    storageUsedBytes
    storageLimitBytes
    subscription {
      tier
      billingStatus
      trialEndsAt
    }
  }
}
    `) as unknown as TypedDocumentString<MyOrganizationsQuery, MyOrganizationsQueryVariables>;
export const OrganizationUsersDocument = new TypedDocumentString(`
    query OrganizationUsers {
  users {
    id
    firstName
    lastName
    name
    email
    role
    joinedAt
    createdAt
    avatar {
      url
    }
  }
}
    `) as unknown as TypedDocumentString<OrganizationUsersQuery, OrganizationUsersQueryVariables>;
export const RemoveUserFromOrganizationDocument = new TypedDocumentString(`
    mutation RemoveUserFromOrganization($organizationId: ID!, $userId: ID!) {
  removeUserFromOrganization(organizationId: $organizationId, userId: $userId)
}
    `) as unknown as TypedDocumentString<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>;
export const UpdateUserRoleInOrganizationDocument = new TypedDocumentString(`
    mutation UpdateUserRoleInOrganization($organizationId: ID!, $userId: ID!, $role: UserOrganizationRole!) {
  updateUserRoleInOrganization(
    organizationId: $organizationId
    userId: $userId
    role: $role
  )
}
    `) as unknown as TypedDocumentString<UpdateUserRoleInOrganizationMutation, UpdateUserRoleInOrganizationMutationVariables>;
export const InviteUserToOrganizationDocument = new TypedDocumentString(`
    mutation InviteUserToOrganization($organizationId: ID!, $email: String!, $role: UserOrganizationRole!, $firstname: String!, $lastname: String) {
  inviteUserToOrganization(
    organizationId: $organizationId
    email: $email
    role: $role
    firstname: $firstname
    lastname: $lastname
  )
}
    `) as unknown as TypedDocumentString<InviteUserToOrganizationMutation, InviteUserToOrganizationMutationVariables>;
export const InviteUsersToOrganizationDocument = new TypedDocumentString(`
    mutation InviteUsersToOrganization($organizationId: ID!, $invitees: [InviteUserInput!]!) {
  inviteUsersToOrganization(organizationId: $organizationId, invitees: $invitees)
}
    `) as unknown as TypedDocumentString<InviteUsersToOrganizationMutation, InviteUsersToOrganizationMutationVariables>;
export const OrganizationInvitationsDocument = new TypedDocumentString(`
    query OrganizationInvitations {
  invitations {
    id
    email
    role
    createdAt
    expiresAt
    acceptedAt
  }
}
    `) as unknown as TypedDocumentString<OrganizationInvitationsQuery, OrganizationInvitationsQueryVariables>;
export const RevokeInvitationDocument = new TypedDocumentString(`
    mutation RevokeInvitation($id: ID!) {
  revokeInvitation(id: $id)
}
    `) as unknown as TypedDocumentString<RevokeInvitationMutation, RevokeInvitationMutationVariables>;
export const AcceptInvitationDocument = new TypedDocumentString(`
    mutation AcceptInvitation($token: String!) {
  acceptInvitation(token: $token) {
    success
    error
    organization {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const UpdateOrganizationDocument = new TypedDocumentString(`
    mutation UpdateOrganization($id: ID!, $input: UpdateOrganizationInput!) {
  updateOrganization(id: $id, input: $input) {
    id
    name
    logo {
      url
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const DeleteOrganizationDocument = new TypedDocumentString(`
    mutation DeleteOrganization($id: ID!, $password: String!) {
  deleteOrganization(id: $id, password: $password)
}
    `) as unknown as TypedDocumentString<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const CreateOrganizationDocument = new TypedDocumentString(`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    id
    name
    slug
    role
  }
}
    `) as unknown as TypedDocumentString<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const SlugAvailableDocument = new TypedDocumentString(`
    query SlugAvailable($slug: String!) {
  slugAvailable(slug: $slug)
}
    `) as unknown as TypedDocumentString<SlugAvailableQuery, SlugAvailableQueryVariables>;
export const InviteOnboardingUsersDocument = new TypedDocumentString(`
    mutation InviteOnboardingUsers($organizationId: ID!, $invitees: [OnboardingInviteInput!]!, $message: String) {
  inviteOnboardingUsers(
    organizationId: $organizationId
    invitees: $invitees
    message: $message
  )
}
    `) as unknown as TypedDocumentString<InviteOnboardingUsersMutation, InviteOnboardingUsersMutationVariables>;
export const MyProjectsDocument = new TypedDocumentString(`
    query MyProjects {
  projects {
    id
    name
    srid
    organizationId
    storageUsedBytes
  }
}
    `) as unknown as TypedDocumentString<MyProjectsQuery, MyProjectsQueryVariables>;
export const GetProjectDocument = new TypedDocumentString(`
    query GetProject($id: ID!) {
  project(id: $id) {
    id
    name
    description
    srid
    organizationId
    initialPosition
    initialAngle
  }
}
    `) as unknown as TypedDocumentString<GetProjectQuery, GetProjectQueryVariables>;
export const GetSharedProjectDocument = new TypedDocumentString(`
    query GetSharedProject {
  sharedProject {
    id
    name
    srid
    organizationId
    initialPosition
    initialAngle
    organization {
      name
      slug
      logo {
        url
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetSharedProjectQuery, GetSharedProjectQueryVariables>;
export const CreateProjectDocument = new TypedDocumentString(`
    mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    id
    name
    srid
  }
}
    `) as unknown as TypedDocumentString<CreateProjectMutation, CreateProjectMutationVariables>;
export const GetProjectJobsDocument = new TypedDocumentString(`
    query GetProjectJobs($projectId: ID!) {
  jobs(projectId: $projectId) {
    id
    type
    status
    inputJson
    outputJson
    logs
    errorLogs
    startedAt
    completedAt
    estimatedCompletion
    leaseUntil
    attempts
    isLeaf
    batchId
    parentItemId
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetProjectJobsQuery, GetProjectJobsQueryVariables>;
export const GetProjectJobsByBatchDocument = new TypedDocumentString(`
    query GetProjectJobsByBatch($batchId: ID!) {
  jobs: jobsByBatch(batchId: $batchId) {
    id
    type
    status
    inputJson
    outputJson
    logs
    errorLogs
    startedAt
    completedAt
    estimatedCompletion
    leaseUntil
    attempts
    isLeaf
    batchId
    parentItemId
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetProjectJobsByBatchQuery, GetProjectJobsByBatchQueryVariables>;
export const GetProjectLinksDocument = new TypedDocumentString(`
    query GetProjectLinks($projectId: ID!) {
  projectLinks(projectId: $projectId) {
    id
    projectId
    name
    token
    hasPassword
    expiresAt
    createdAt
    createdById
    status
    createdBy {
      id
      name
      email
      avatar {
        url
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetProjectLinksQuery, GetProjectLinksQueryVariables>;
export const GetAllProjectLinksDocument = new TypedDocumentString(`
    query GetAllProjectLinks {
  allProjectLinks {
    id
    projectId
    project {
      id
      name
    }
    name
    token
    hasPassword
    expiresAt
    createdAt
    createdById
    status
    createdBy {
      id
      name
      email
      avatar {
        url
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAllProjectLinksQuery, GetAllProjectLinksQueryVariables>;
export const OrganizationWithSubscriptionDocument = new TypedDocumentString(`
    query OrganizationWithSubscription($id: ID!) {
  organization(id: $id) {
    id
    name
    storageUsedBytes
    storageLimitBytes
    subscription {
      tier
      billingStatus
      collectionMethod
      billingInterval
      storageBlocks
      storageLimitBytes
      currentPeriodEnd
      cancelAtPeriodEnd
      cancelAt
      scheduledTier
      scheduledStorageBlocks
      scheduledChangeAt
      trialEndsAt
    }
  }
}
    `) as unknown as TypedDocumentString<OrganizationWithSubscriptionQuery, OrganizationWithSubscriptionQueryVariables>;
export const SubscriptionDetailsDocument = new TypedDocumentString(`
    query SubscriptionDetails($organizationId: ID!) {
  subscriptionDetails(organizationId: $organizationId) {
    info {
      tier
      billingStatus
      collectionMethod
      billingInterval
      storageBlocks
      storageLimitBytes
      currentPeriodEnd
      cancelAtPeriodEnd
      cancelAt
      scheduledTier
      scheduledStorageBlocks
      scheduledChangeAt
      trialEndsAt
    }
    invoices {
      id
      number
      status
      amountDue
      amountPaid
      currency
      created
      dueDate
      hostedInvoiceUrl
      pdfUrl
    }
    nextInvoicePreview {
      amountDue
      currency
      periodStart
      periodEnd
      lines {
        description
        amount
        quantity
      }
    }
    discount {
      promoCodeId
      couponId
      name
      percentOff
      amountOff
      expiresAt
    }
  }
}
    `) as unknown as TypedDocumentString<SubscriptionDetailsQuery, SubscriptionDetailsQueryVariables>;
export const ValidatePromoCodeDocument = new TypedDocumentString(`
    query ValidatePromoCode($code: String!) {
  validatePromoCode(code: $code) {
    valid
    name
    percentOff
    amountOff
  }
}
    `) as unknown as TypedDocumentString<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>;
export const SubscriptionPricingDocument = new TypedDocumentString(`
    query SubscriptionPricing {
  subscriptionPricing {
    currency
    tiers {
      tier
      name
      description
      storage {
        monthly {
          upTo
          unitAmount
          unitAmountDecimal
        }
        annual {
          upTo
          unitAmount
          unitAmountDecimal
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SubscriptionPricingQuery, SubscriptionPricingQueryVariables>;